import React from "react";
import { Link } from "gatsby";
import "./NavLinks.scss";
import { headerLinks } from "@constants";
import Dropdown from "./Dropdown/Dropdown";

const NavLinks = ({ handlePopup, path }) => (
    <div className="header-links">
        <Dropdown path={path} handlePopup={handlePopup} />
        {/* eslint-disable-next-line array-callback-return,consistent-return */}
        {headerLinks.map((link, index) => {
            if (link.forDesktop) {
                const { linkName, path } = link;
                return (
                    <Link
                        key={index}
                        to={path}
                        className="header-links__link"
                        activeClassName="header-links__link-active"
                    >
                        {linkName}
                    </Link>
                );
            }
        })}
    </div>
);

export default NavLinks;
